import {
  Button,
  Dialog,
  Divider,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { StatusSwitch } from 'src/components/VemigoGrid/VemigoStarusFeild';
import VemigoTextFeild from 'src/components/VemigoGrid/VemigoTextFeild';
import {
  customerPageStyling,
  customerStyle,
  useStyles
} from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { useCustomerData } from '../customerData';
import { AddBooking } from './addBooking';
import { useCustomerBookingCart } from '../selectedCustomerData';
import { BasicInfoModel } from 'src/models/customer/basicInfoModel';
import { AreaModel } from 'src/models/regions/area';
import { MessagePopUp } from '../popUpMessage';
import { CustomerCartServicess } from 'src/services/customer/customerCartServices';
import { OrderSummary } from '../../subscriptions/createSubscription/orderSummary';
import { useNavigate } from 'react-router-dom';

interface CustomerBookingCartProps {
  onBookingSuccess?: () => void;
  onBack?: () => void;
}

export const CustomerBookingCart: React.FC<CustomerBookingCartProps> = ({
  onBookingSuccess,
  onBack
}) => {
  const {
    selectedCustomerData,
    setSelectedCustomer,
    setChangeData,
    carList,
    CartId,
    addressList,
    setCartCards,
    cartCardsData,
    setOpenAddBookingPage,
    handleGetCartData
  } = useCustomerBookingCart();

  const navigate = useNavigate();

  const { allCities, allAreas } = useCustomerData();

  const dataModel = {
    customerId: selectedCustomerData?.id || 0,
    customerName: selectedCustomerData?.firstAndMiddleName || '',
    customerLastName: selectedCustomerData?.lastName || '',
    cityId: selectedCustomerData?.city.id || 0,
    areaId: selectedCustomerData?.area.id || 0
  };

  const [newData, setNewData] = useState(dataModel);
  const [selectedCityList, setSelectedCityList] = useState(allCities || []);
  const [selectedCityId, setSelectedCityId] = useState(
    selectedCustomerData?.city.id || ''
  );
  const [selectedAreaList, setSelectedAreaList] = useState(allAreas || []);
  const [selectedAreaId, setSelectedAreaId] = useState(
    selectedCustomerData?.area.id || ''
  );

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [paymentData, setPaymentData] = useState({
    paymentMethod: true,
    paymentDetails: '',
    note: ''
  });
  const [conformBooking, setConformBooking] = useState(false);

  useEffect(() => {
    setSelectedAreaList(
      allAreas.filter((x) => x.city.id === selectedCustomerData.city.id)
    );
    handleGetCartData('Get');
  }, []);

  const handleDataChange = (fieldName, value) => {
    setNewData({ ...newData, [fieldName]: value });

    if (fieldName === 'cityId') {
      setSelectedAreaList(allAreas.filter((x) => x.city.id === value));
      setSelectedAreaId('');
      const area: AreaModel = {
        id: 0,
        name: '',
        pinCode: 0,
        status: false,
        city: {
          id: 0,
          name: '',
          state: {}
        }
      };
      const changedCity: BasicInfoModel = {
        ...selectedCustomerData,
        city: allCities?.find((x) => x.id === value),
        area: area
      };
      setChangeData(false);
      setSelectedCustomer(changedCity);
    } else if (fieldName === 'areaId') {
      const changedArea = {
        ...selectedCustomerData,
        area: allAreas?.find((x) => x.id === value)
      };
      setChangeData(false);
      setSelectedCustomer(changedArea);
    }
  };

  const handleReset = () => {
    CustomerCartServicess.deleteData(CartId)
      .then(() => {
        setDeleteConfirmationOpen(false);
        setCartCards([
          {
            id: `cardNew`,
            cityId: selectedCustomerData?.city.id,
            areaId: selectedCustomerData?.area.id,
            car: carList,
            address:
              addressList.addresses.filter(
                (x) => x.cityID === selectedCustomerData.city.id
              ) || [],
            services: [],
            totalDiscount: 0,
            totalTax: 0,
            totalAmount: 0,
            selectedCar: true,
            selectedAddress: true
          }
        ]);
        enqueueSnackbar(` Service removed successfully`, {
          variant: 'success'
        });
      })
      .catch(() => {
        enqueueSnackbar(` Error in reseting the cart `, {
          variant: 'error'
        });
        return;
      });
  };
  const handleBook = () => {
    setConformBooking(true);
  };

  const handleCloseDilogBox = () => {
    setConformBooking(false);

    if (onBookingSuccess) {
      onBookingSuccess();
    }
  };

  const getFieldValue = (fieldId) => {
    if (fieldId.includes('.')) {
      const [parent, child] = fieldId.split('.');
      return newData[parent][child] || '';
    }
    return newData[fieldId] || '';
  };

  const allFields = [
    {
      id: 'customerName',
      field: 'textField',
      title: 'First Name',
      type: 'text',
      size: 6
    },
    {
      id: 'customerLastName',
      field: 'textField',
      title: 'Last Name',
      type: 'text',
      size: 6
    },
    {
      id: 'cityId',
      field: 'Select',
      title: 'City*',
      type: 'select City',
      selectedId: selectedCityId,
      dataList: selectedCityList,
      function: setSelectedCityId,
      size: 6
    },
    {
      id: 'areaId',
      field: 'Select',
      title: 'Area*',
      type: 'Select Area',
      selectedId: selectedAreaId,
      dataList: selectedAreaList,
      function: setSelectedAreaId,
      size: 6
    }
  ];

  const totalOfCards = [
    {
      id: 'totalServices',
      title: 'Total Services',
      value: cartCardsData.reduce((sum, card) => sum + card.services.length, 0)
    },
    {
      id: 'totalPrice',
      title: 'Total Price',
      value: parseFloat(
        cartCardsData
          .reduce((sum, card) => sum + card.totalAmount, 0)
          .toFixed(2)
      )
    },
    {
      id: 'totalDiscount',
      title: 'Total Discount',
      value: parseFloat(
        cartCardsData
          .reduce((sum, card) => sum + card.totalDiscount, 0)
          .toFixed(2)
      )
    },
    {
      id: 'totalTax',
      title: 'Total Tax',
      value: parseFloat(
        cartCardsData.reduce((sum, card) => sum + card.totalTax, 0).toFixed(2)
      )
    },
    {
      id: 'finalAmount',
      title: 'Final Amount',
      value: parseFloat(
        cartCardsData
          .reduce((sum, card) => sum + card.totalAmount, 0)
          .toFixed(2)
      )
    }
  ];

  return (
    <>
      <div>
        <div style={customerStyle.recentSearchStyle}>Customer Booking Cart</div>
        <Divider sx={customerStyle.divider} />
        <Grid container spacing={2} style={customerPageStyling.container}>
          {selectedCustomerData ? (
            <>
              {allFields?.map((field) => (
                <Grid item xs={field.size} key={field.id}>
                  <Typography style={useStyles.formTitle}>
                    {field.title}
                  </Typography>
                  {field.field === 'textField' && (
                    <VemigoTextFeild
                      style={useStyles.formControl}
                      id={field.id}
                      type={field.type}
                      fullWidth
                      autoFocus={false}
                      counter={false}
                      value={getFieldValue(field.id) || ''}
                      onChange={(e) =>
                        handleDataChange(field.id, e.target.value)
                      }
                      readonly={true}
                      key={`textfield-${field.id}`}
                    />
                  )}
                  {field.field === 'Select' && (
                    <Select
                      displayEmpty
                      style={{ ...useStyles.formControl }}
                      fullWidth
                      value={field.selectedId}
                      onChange={(e) => {
                        handleDataChange(field.id, e.target.value);
                        field.function(e.target.value);
                      }}
                    >
                      <MenuItem value="" disabled key={`${field.id}-empty`}>
                        <em>{field.type}</em>
                      </MenuItem>
                      {field.dataList?.map((data) => (
                        <MenuItem key={data.id} value={data.id}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  {field.field === 'status' && (
                    <StatusSwitch
                      newData={newData}
                      handleSwitchChange={handleDataChange}
                      field={field.id}
                    />
                  )}
                </Grid>
              ))}
            </>
          ) : (
            <Grid
              container
              item
              marginTop={'6vh'}
              xs={12}
              justifyContent="center"
              alignItems="center"
            >
              <Button color="primary" fullWidth>
                + Customer
              </Button>
            </Grid>
          )}

          <AddBooking />

          <div
            style={{
              width: '100%',
              padding: '18px',
              marginTop: '18px',
              backgroundColor: 'rgba(219, 240, 255, 0.3)',
              border: 'dashed 2px #2196F3',
              boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.5)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant="h3">Final Amount</Typography>
              <span></span>
            </div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              {totalOfCards?.map((totals) => (
                <div
                  key={`${totals.id}-TotalsKey`}
                  style={{
                    minWidth: '60px',
                    minHeight: '30px',
                    margin: '12px',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <span key={`${totals.id}-TotalsKey-Titles`}>
                    {totals.title}
                  </span>
                  <input
                    key={`${totals.id}-TotalsKey-input`}
                    style={{
                      width: '110px',
                      backgroundColor: 'transparent',
                      padding: '13px 15px',
                      borderRadius: '9px',
                      height: '50px',
                      border: 'solid 1px #ccc',
                      textAlign: 'right',
                      fontSize: '15px',
                      overflow: 'hidden',
                      marginTop: '9px'
                    }}
                    value={totals.value}
                    readOnly
                  />
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              width: '100%',
              padding: '18px',
              marginTop: '20px',
              backgroundColor: 'rgba(251, 251, 251, 1)',
              border: 'solid 1px #e0e0e0',
              borderRadius: '4px',
              display: 'flex',
              flexDirection: 'column',
              gap: '1px'
            }}
          >
            <Typography variant="h3">Payment Details</Typography>

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={2}>
                    <Typography style={useStyles.formTitle}>
                      Payment Method
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <Grid container alignItems="center">
                      <Grid item>
                        <Switch
                          checked={paymentData.paymentMethod}
                          onChange={() =>
                            setPaymentData({
                              ...paymentData,
                              paymentMethod: !paymentData.paymentMethod
                            })
                          }
                          color="primary"
                        />
                      </Grid>
                      <Grid item>
                        <Typography
                          style={{
                            color: paymentData.paymentMethod ? 'green' : 'red'
                          }}
                          sx={{ marginTop: '4px' }}
                        >
                          {paymentData.paymentMethod ? 'Cash' : 'Online'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Typography style={useStyles.formTitle}>
                  Payment Details / Transaction ID
                </Typography>
                <br />
                <TextField
                  style={useStyles.formControl}
                  autoFocus
                  margin="dense"
                  id="paymentDetails"
                  placeholder="Payment details/ Transaction Id..."
                  type="text"
                  fullWidth
                  value={paymentData.paymentDetails}
                  onChange={(e) => {
                    const inputValue = e.target.value;

                    const regex = /^[A-Za-z0-9 .]+$/;

                    if (regex.test(inputValue) || inputValue === '') {
                      setPaymentData({
                        ...paymentData,
                        paymentDetails: e.target.value
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography style={useStyles.formTitle}>Note *</Typography>
                <br />
                <TextField
                  style={useStyles.formControl}
                  autoFocus
                  margin="dense"
                  id="Note"
                  placeholder=" "
                  type="text"
                  fullWidth
                  value={paymentData.note}
                  onChange={(e) => {
                    const inputValue = e.target.value;

                    const regex = /^[A-Za-z0-9 .]+$/;

                    if (regex.test(inputValue) || inputValue === '') {
                      setPaymentData({
                        ...paymentData,
                        note: e.target.value
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '20px',
              width: '100%',
            }}
          >
            <Button
              style={customerPageStyling.addBooking(false).resetBtn}
              color="primary"
              variant="contained"
              onClick={() => {
                setDeleteConfirmationOpen(true);
              }}
            >
              Reset
            </Button>
            <Button
              style={customerPageStyling.addBooking(false).backBtn}
              color="primary"
              variant="contained"
              onClick={() => {
                if (onBack) {
                  setOpenAddBookingPage(false)
                }
              }}
            >
              Back
            </Button>
            <Button
              style={customerPageStyling.addBooking(false).bookBtn}
              color="primary"
              variant="contained"
              disabled={
                cartCardsData.reduce(
                  (sum, card) => sum + card.services.length,
                  0
                ) !== 0
                  ? false
                  : true
              }
              onClick={() => {
                handleBook();
              }}
            >
              Book
            </Button>
          </div>
        </Grid>
        <MessagePopUp
          openPopUp={deleteConfirmationOpen}
          cancel={() => setDeleteConfirmationOpen(false)}
          conformation={handleReset}
          message="Are you sure you want to clear cart? This action cannot be undone."
        />
        <Dialog
          open={conformBooking}
          onClose={handleCloseDilogBox}
          maxWidth="md"
        >
          <OrderSummary
            cityId={cartCardsData[0]?.cityId}
            areaId={cartCardsData[0]?.areaId}
            open={conformBooking}
            handleClose={handleCloseDilogBox}
            paymentDetails={paymentData}
            page="Booking"
            onBack={() => setConformBooking(false)}
          />
        </Dialog>
      </div>
    </>
  );
};
